import { Box, SxProps, Theme } from '@mui/material'
import { FC, ReactNode } from 'react'

interface CaptionedCellProps {
  caption?: ReactNode
  lineClamp?: number
  primary?: ReactNode
  sx?: SxProps<Theme>
}

export const CaptionedCell: FC<CaptionedCellProps> = ({ caption, lineClamp = 2, primary, sx }) => (
  <Box sx={[{ minWidth: 0, py: 1 }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}>
    <Box
      sx={{
        display: '-webkit-box',
        lineHeight: 1.35,
        overflow: 'hidden',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: lineClamp,
        whiteSpace: 'normal',
        wordBreak: 'break-word',
      }}
    >
      {primary}
    </Box>
    {caption && (
      <Box sx={{ color: 'text.secondary', fontSize: 12, fontWeight: 500, lineHeight: 1.4 }}>{caption}</Box>
    )}
  </Box>
)

export const renderCaptionedCell = (primary?: ReactNode, caption?: ReactNode, lineClamp = 2) => (
  <CaptionedCell primary={primary} caption={caption} lineClamp={lineClamp} />
)
